import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { AppHeader } from '@/components/layout/AppHeader';

export default function JoinPage() {
  const navigate = useNavigate();
  const [sessionCode, setSessionCode] = useState('');

  const handleJoinSession = (e: React.FormEvent) => {
    e.preventDefault();
    const code = sessionCode.trim().toUpperCase();
    if (code) {
      navigate(`/student/${code}`);
    }
  };

  const canSubmit = sessionCode.trim().length >= 6;

  return (
    <div className="flex min-h-screen flex-col bg-background">
      <AppHeader
        right={
          <Button variant="ghost" onClick={() => navigate('/professor')}>
            Professor sign in
          </Button>
        }
      />
      <main className="flex flex-1 items-center justify-center px-6 py-16">
        <div className="w-full max-w-md rounded-2xl border bg-card p-8 shadow-soft sm:p-10">
          <h1 className="text-2xl font-bold tracking-tight">Join a class</h1>
          <p className="mt-1.5 text-sm text-muted-foreground">
            Enter the six-character code your professor shared.
          </p>

          <form onSubmit={handleJoinSession} className="mt-8 space-y-5">
            <div className="space-y-2">
              <Label htmlFor="class-code">Class code</Label>
              <Input
                id="class-code"
                type="text"
                value={sessionCode}
                onChange={(e) => setSessionCode(e.target.value.toUpperCase())}
                placeholder="ABC123"
                maxLength={6}
                autoComplete="off"
                autoCapitalize="characters"
                spellCheck={false}
                className="h-14 rounded-lg text-center text-2xl font-semibold uppercase tracking-[0.35em] placeholder:tracking-[0.35em] placeholder:text-muted-foreground/50 md:text-2xl"
              />
            </div>
            <Button type="submit" variant="brand" size="lg" className="w-full" disabled={!canSubmit}>
              Continue
              <ArrowRight aria-hidden />
            </Button>
          </form>

          <p className="mt-6 text-center text-xs text-muted-foreground">
            Don't have a code? Ask your professor. They'll see it at the top of their dashboard.
          </p>
        </div>
      </main>
    </div>
  );
}
